<template>
  <b-modal
    size="lg"
    id="modalDisponibilita"
    title="Prestazioni non disponibili"
    hide-header-close
    ref="modalDisponibilita"
    no-close-on-backdrop
    no-close-on-esc
  > <p>Nel tuo distretto non sono presenti le seguenti prestazioni.</p>
    <p class="mb-3">Vuoi verificare altre proposte sull'intero territorio regionale?</p>
    <b-table :items="nonErogabili" :fields="fields" striped borderless>
    </b-table>
    <template #modal-footer="{}">
      <b-button class="btn-secondary" @click="no()">
        No
      </b-button>
      <b-button class="btn-primary" @click="si()">
        Si
      </b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  props: {
    nonErogabili: Array,
  },
  data() {
    return {
      fields: [
        {
          label: "Prestazione",
          key: "descrizionePrestazione",
        },
        {
          label: "Codice Catalogo",
          key: "codiceNomenclatoreRegionale",
        },
      ],
    };
  },
  methods: {
    show() {
      let me = this;
      me.$refs["modalDisponibilita"].show();
    },
    si() {
      console.log("si");
      this.$emit('si');
    },
    no() {
      this.$emit('no');
    },
  },
};
</script>
